export default require('./TabChapters').default
